module.exports = __webpack_public_path__ + "static/media/CA_CheckIcon.19802722.svg";